import { type StackProps, GridLegacy as Grid } from '@mui/material';

import { Section } from '@rumblefish/ui/Rumblefish23Theme';
import {
  StyledStack,
  StyledTwoTitles,
  StyledFirstTitle,
  StyledServiceItem,
  StyledServiceIcon,
  StyledServiceIconWrapper,
  StyledServiceIconBackground,
  StyledServiceTitle,
  StyledServiceDescription,
} from './styles';
import { whyChooseRFData } from './WhyChooseRF.data';

export const WhyChooseRF = ({ ...props }: StackProps) => {
  return (
    <Section width="normal">
      <StyledStack {...props}>
        <StyledTwoTitles>
          <StyledFirstTitle variant="display_sm">
            Why Choose Rumble Fish?
          </StyledFirstTitle>
        </StyledTwoTitles>

        <Grid container columnSpacing={{ sm: 8 }} rowSpacing={{ xs: 6, sm: 8 }}>
          {whyChooseRFData.map((data, index) => (
            <StyledServiceItem key={index} item xs={12} md={6}>
              <div>
                <StyledServiceIconWrapper>
                  <StyledServiceIconBackground>
                    <StyledServiceIcon src={data.img} alt={data.title} />
                  </StyledServiceIconBackground>
                </StyledServiceIconWrapper>
              </div>
              <div>
                <StyledServiceTitle variant="strong_400">
                  {data.title}
                </StyledServiceTitle>
                <br />
                <StyledServiceDescription variant="regular_300">
                  {data.description}
                </StyledServiceDescription>
              </div>
            </StyledServiceItem>
          ))}
        </Grid>
      </StyledStack>
    </Section>
  );
};
